__turbopack_context__.v({
  "acct": "mobile-nav-module__WyOPQq__acct",
  "acctEmail": "mobile-nav-module__WyOPQq__acctEmail",
  "auth": "mobile-nav-module__WyOPQq__auth",
  "avatar": "mobile-nav-module__WyOPQq__avatar",
  "cta": "mobile-nav-module__WyOPQq__cta",
  "ctaGhost": "mobile-nav-module__WyOPQq__ctaGhost",
  "ctaPrimary": "mobile-nav-module__WyOPQq__ctaPrimary",
  "drawer": "mobile-nav-module__WyOPQq__drawer",
  "head": "mobile-nav-module__WyOPQq__head",
  "iconBtn": "mobile-nav-module__WyOPQq__iconBtn",
  "link": "mobile-nav-module__WyOPQq__link",
  "linkActive": "mobile-nav-module__WyOPQq__linkActive",
  "linkDanger": "mobile-nav-module__WyOPQq__linkDanger",
  "linkLabel": "mobile-nav-module__WyOPQq__linkLabel",
  "menuButton": "mobile-nav-module__WyOPQq__menuButton",
  "nav": "mobile-nav-module__WyOPQq__nav",
  "open": "mobile-nav-module__WyOPQq__open",
  "root": "mobile-nav-module__WyOPQq__root",
  "scrim": "mobile-nav-module__WyOPQq__scrim",
  "sep": "mobile-nav-module__WyOPQq__sep",
  "signOutForm": "mobile-nav-module__WyOPQq__signOutForm",
  "wordmark": "mobile-nav-module__WyOPQq__wordmark",
});
